/**
 * CDN versions for lazy-loaded libraries.
 * Keep these in sync with package.json for type compatibility.
 */
export const CDN_VERSIONS = {
  xterm: '5.3.0',
  xtermAddonFit: '0.8.0',
  xtermAddonSearch: '0.13.0',
  highlightJs: '11.11.1',
  echarts: '5.6.0',
  tiptap: '2.27.2',
} as const;

/**
 * Base CDN URL for jsdelivr ESM imports
 */
export const CDN_BASE = 'https://cdn.jsdelivr.net/npm';
